// immediate improvements (will apply to new features and api migration)
// - separate store files per service/controller?
// - reduce repeated large codes
// - maximize of enums use
// - taking advantage of async await
// - set 'src' as base url with alias @ for for better definition of paths

// others:
// - shared docs for old API endpoint paired with New Endpoint API for migration
// - remove debugger script before deployment, replace with centralized console log appears when error only
// - reduce warnings on logs
// - remove unused script
import { Post, Get, Put, Delete } from "@/utils";
import { ApiPath, UserRoles } from "@/enums";

export default {
  namespaced: true,
  state: {


  },
  mutations: {

  },
  actions: {
    async checkuserprofilepagesetting({ }, requestId) {
      const isApprentice = this.state.account.current_user.roles.includes('Apprentice');
      if (isApprentice) {
        const { data: userprofilepagesetting } = await Get(
          `${ApiPath.Apprentice}/checkuserprofilepagesetting`,
          requestId
        );
        return userprofilepagesetting;
      } else {
        const { data: userprofilepagesetting } = await Get(
          `${ApiPath.JobSeeker}/checkuserprofilepagesetting`,
          requestId
        );
        return userprofilepagesetting;
      }
    },
    async getuserprofilepagesettings({ }, requestId) {
      const isApprentice = this.state.account.current_user.roles.includes('Apprentice');
      if (isApprentice) {
        const { data: userprofilepagesetting } = await Get(
          `${ApiPath.Apprentice}/getuserprofilepagesettings`,
          requestId
        );
        return userprofilepagesetting;
      } else {
        const { data: userprofilepagesetting } = await Get(
          `${ApiPath.JobSeeker}/getuserprofilepagesettings`,
          requestId
        );
        return userprofilepagesetting;
      }
    },
    async updateresume({ }, obj) {
      const isApprentice = this.state.account.current_user.roles.includes('Apprentice');
      if (isApprentice) {
        const { data: userprofilepagesetting } = await Put(
          `${ApiPath.Apprentice}/updateresume?profileId=${obj.profileId}`
        );
        return userprofilepagesetting;
      } else {
        const { data: userprofilepagesetting } = await Put(
          `${ApiPath.JobSeeker}/updateresume?profileId=${obj.profileId}`
        );
        return userprofilepagesetting;
      }

    },
    async saveprofilepagesetting({ }, body) {
      const isApprentice = this.state.account.current_user.roles.includes('Apprentice');
      if (isApprentice) {
        const { data: userprofilepagesetting } = await Post(
          `${ApiPath.Apprentice}/saveprofilepagesetting`,
          body
        );
        return userprofilepagesetting;
      } else {
        const { data: userprofilepagesetting } = await Post(
          `${ApiPath.JobSeeker}/saveprofilepagesetting`,
          body
        );
        return userprofilepagesetting;
      }
    },
    async removeprofilepagesetting({ }, pageSettingId) {
      const isApprentice = this.state.account.current_user.roles.includes('Apprentice');
      if (isApprentice) {
        const { data: userprofilepagesetting } = await Delete(
          `${ApiPath.Apprentice}/removeprofilepagesetting?pageSettingId=${pageSettingId}`
        );
        return userprofilepagesetting;
      } else {
        const { data: userprofilepagesetting } = await Delete(
          `${ApiPath.JobSeeker}/removeprofilepagesetting?pageSettingId=${pageSettingId}`
        );
        return userprofilepagesetting;
      }
    },
    //TODO: Missing endpoint
    updateprofileprivacy({ }, profilePrivacy) {
      const userid =
        sessionStorage.getItem("debugid") == null
          ? null
          : sessionStorage.getItem("debugid");
      return axios
        .post(
          `${process.env.VUE_APP_API_BASE_URI}apprentice/updateprofileprivacy?userId=${userid}&profileprivacy=${profilePrivacy}`
        )
        .then((res) => {
          return res;
        })
        .catch((res) => {
          const errors = res.response;
          throw errors;
        });
    },

  }
}